export default __webpack_public_path__ + "static/media/dcos.c84af143.svg";